import React from "react";
import { useTranslation } from "react-i18next";

// 404. User facing, so copy comes through i18next.
export default function NotFound() {
  const { t } = useTranslation();
  return (
    <main
      data-testid="error-404"
      className="min-h-screen flex flex-col items-center justify-center text-center px-6"
      style={{ background: "var(--bg-primary)" }}
    >
      <h1 className="text-3xl sm:text-4xl font-bold mb-3" style={{ color: "var(--text-primary)" }}>
        {t("errors.notFoundTitle")}
      </h1>
      <p className="text-base mb-8" style={{ color: "var(--text-secondary)" }}>
        {t("errors.notFoundBody")}
      </p>
      <a
        data-testid="error-404-home"
        href="/"
        className="px-6 py-3 rounded-full text-sm font-semibold"
        style={{ background: "var(--accent-primary)", color: "#fff" }}
      >
        {t("errors.backHome")}
      </a>
    </main>
  );
}
